import { IUserInfo } from "components/widgets/types";
import { UserListWidget } from "components/widgets/UserListWidget";

interface IUserListWidgetAlive {
  title: string;
  link: string;
  items: IUserInfo[];
  className?: string;
  list?: boolean;
}

export const UserListWidgetAlive = (props: IUserListWidgetAlive) => {
  return (
    <UserListWidget
      title={props.title}
      link={props.link}
      items={props.items}
      className={props.className}
      list={props.list}
    />
  );
};
